export default __webpack_public_path__ + "static/media/Ahnefet.4cff0fc1.jpg";